import { RequestStatus } from 'legacy/lut/configs/service'
import { createSelector } from 'reselect'

import { selectAssortmentState } from './selectAssortmentState'

export const selectIsLoading = createSelector(
  [selectAssortmentState],
  ({ categories, items, groups }) => {
    const isCategoriesLoading = categories.status === RequestStatus.PENDING
    const isItemsLoading = items.status === RequestStatus.PENDING
    const isGroupsLoading = groups.status === RequestStatus.PENDING

    return isCategoriesLoading || isItemsLoading || isGroupsLoading
  }
)
